import * as React from 'react';
import type { components } from 'types/schemas/api-schema';
import * as tokenUtils from 'utils/token';

export const initialState = {
  token: tokenUtils.rehydrateToken(),
  user: null as components['schemas']['User'] | null,
  licenseExpires: null as Date | null,
  authenticationError: null,
  userDetailsError: null,
  unauthenticationError: null,
  passwordResetError: null,
  passwordUpdateError: null,
};

type AuthState = {
  state: typeof initialState;
  unauthenticate: () => void;
  getUserDetails: () => void;
  changeDefaultScore: (defaultScore: 'risk_score' | 'deviation_score') => void;
};

const AuthState = React.createContext({
  state: { ...initialState },
} as AuthState);

export default AuthState;
